import React from 'react';
import { colors } from 'design-system';
import VectorIcon from './VectorIcon';
import IconProps from './IconProps';

const UnitSelectionIcon = ({
  width = 56,
  height = 56,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <circle
      cx="28"
      cy="28.001"
      r="26"
      fill="#0D2E68"
      stroke="url(#paint0_linear_11785:45789)"
      strokeWidth="4"
    />
    <path
      d="M37.625 17.0483H18.375C17.613 17.0483 17 17.5099 17 18.0836V38.0977C17 38.6714 
      17.613 39.133 18.375 39.133H37.625C38.387 39.133 39 38.6714 39 38.0977V18.0836C39 
      17.5099 38.387 17.0483 37.625 17.0483ZM20.6667 21.8793C20.6667 21.4998 21.0792 21.1892 
      21.5833 21.1892H23.4167C23.9208 21.1892 24.3333 21.4998 24.3333 21.8793V23.2596C24.3333 
      23.6392 23.9208 23.9498 23.4167 23.9498H21.5833C21.0792 23.9498 20.6667 23.6392 20.6667 
      23.2596V21.8793ZM20.7583 27.4609L21.4859 26.9174C21.6062 26.8268 21.801 26.8268 21.9214 
      26.9174L23.1016 27.8146L25.8286 25.7787C25.949 25.6881 26.1437 25.6881 26.2641 
      25.7787L26.9859 26.3265C27.1062 26.417 27.1062 26.5637 26.9859 26.6543L23.3078 
      29.3976C23.1875 29.4882 22.9927 29.4882 22.8724 29.3976L20.7583 27.7887C20.638 27.6981 
      20.638 27.5515 20.7583 27.4609ZM24.3333 34.3019C24.3333 34.6815 23.9208 34.9921 23.4167 
      34.9921H21.5833C21.0792 34.9921 20.6667 34.6815 20.6667 34.3019V32.9217C20.6667 32.5421 
      21.0792 32.2315 21.5833 32.2315H23.4167C23.9208 32.2315 24.3333 32.5421 24.3333 
      32.9217V34.3019ZM35.3333 33.9569C35.3333 34.1467 35.1271 34.3019 34.875 
      34.3019H26.625C26.3729 34.3019 26.1667 34.1467 26.1667 33.9569V33.2667C26.1667 33.0769 
      26.3729 32.9217 26.625 32.9217H34.875C35.1271 32.9217 35.3333 33.0769 35.3333 
      33.2667V33.9569ZM35.3333 28.4357C35.3333 28.6255 35.087 28.7808 34.7833 
      28.7808H26.751C26.751 28.7808 28.424 27.4781 28.4927 27.4005H34.7776C35.0812 27.4005 
      35.3276 27.5558 35.3276 27.7456V28.4357H35.3333ZM35.3333 22.9146C35.3333 23.1044 35.1271 
      23.2596 34.875 23.2596H26.625C26.3729 23.2596 26.1667 23.1044 26.1667 22.9146V22.2244C26.1667 22.0346 26.3729 21.8793 26.625 21.8793H34.875C35.1271 21.8793 35.3333 22.0346 
      35.3333 22.2244V22.9146Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11785:45789"
        x1="28"
        y1="4.00098"
        x2="28"
        y2="52.001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={colors.bright_turquoise} />
        <stop offset="1" stopColor="#CEE8FF" />
      </linearGradient>
    </defs>
  </VectorIcon>
);

export default UnitSelectionIcon;
